// extracted by mini-css-extract-plugin
export default {"root":"OkGvB__root","label":"KOXiB__label","select":"pJMbj__select"};